import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';
import DateHelper from 'src/app/helpers/date-helper';
import Employee from 'src/app/model/product/employee';
import { IPInstallerListControllerRequestService } from './service/ip-installer-list-controller-request.service';
import { TourDateChangeService } from './service/tour-date-change.service';

@Component({
  selector: 'tour-page',
  templateUrl: './tour-page.component.html',
  styleUrls: ['./tour-page.component.scss'],
})
export class TourPageComponent implements OnInit {
  placers: Employee[];
  employeesLoaded = false;

  weekDates: moment.Moment[];
  weekDifferential: number = 0;
  selectedDateIndex: number;

  @ViewChild('tourScrollAnchor') tourScrollAnchor: ElementRef;
  @ViewChild('mapScrollAnchor') mapScrollAnchor: ElementRef;
  @ViewChild('overviewScrollAnchor') overviewScrollAnchor: ElementRef;

  constructor(
    private ipInstallerListControllerRequestService: IPInstallerListControllerRequestService,
    private tourDateChangeService: TourDateChangeService
  ) {}

  ngOnInit(): void {
    this.ipInstallerListControllerRequestService
      .IPInstallerList()
      .then((placers: Employee[]) => (this.placers = placers))
      .finally(() => (this.employeesLoaded = true));
    this.initializeWeek();
  }

  private initializeWeek(): void {
    const today = DateHelper.getMomentAtStartOfDay();
    const storedDate = this.tourDateChangeService
      .getTourDateSubject()
      .getValue();
    if (storedDate != null) {
      const weekDiff = DateHelper.calculateCalendarWeekDiff(storedDate, today);
      this.changeWeek(weekDiff, true);
      this.selectDay(storedDate);
    } else {
      this.changeWeek(today.weekday() === 6 ? 1 : 0, true);
      this.selectDay(today);
    }
  }

  changeWeek(weekDifferential: number, init: boolean = false): void {
    this.weekDifferential += weekDifferential;
    this.weekDates = _.range(0, 6).map((i: number) =>
      DateHelper.getMomentAtStartOfDay()
        .weekday(i)
        .add(this.weekDifferential * 7, 'days')
    );
    this.selectedDateIndex = weekDifferential === -1 ? 4 : 0; // pick Friday if navigating to one week earlier
    if (!init) {
      this.tourDateChangeService
        .getTourDateSubject()
        .next(this.weekDates[this.selectedDateIndex]);
    }
  }

  changeSelectedDateIndex(i: number): void {
    this.selectedDateIndex = i;
    this.tourDateChangeService
      .getTourDateSubject()
      .next(this.weekDates[this.selectedDateIndex]);
  }

  selectDay(moment: moment.Moment): void {
    moment = moment.day() === 0 ? moment.add(1, 'days') : moment;
    this.selectedDateIndex = this.weekDates.findIndex((d) =>
      moment.isSame(d, 'day')
    );
    this.tourDateChangeService
      .getTourDateSubject()
      .next(this.weekDates[this.selectedDateIndex]);
  }

  scrollTo(anchor: string) {
    const scrollOption = {
      behavior: 'smooth',
      block: 'start',
    };
    if (anchor === 'TOUR') {
      this.tourScrollAnchor.nativeElement.scrollIntoView(scrollOption);
    } else if (anchor === 'MAP') {
      this.mapScrollAnchor.nativeElement.scrollIntoView(scrollOption);
    }
  }
}
